import { SupplierInvoiceCreationStageType } from "@sellar-io/api-v2/types";

export type ConfirmOrderDialogProps = {
  active: boolean;
  onDismiss: () => void;
  orderId: number;
  invoiceCreationStage: SupplierInvoiceCreationStageType;
  onSuccess?: () => void;
};

export enum ConfirmOrderDialogPage {
  FORM,
  FULFILLMENT,
}
